// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"2ef2b979","349":"fb58503a","434":"af144e43","519":"d9808709","583":"b15951f3","640":"c5531dbe","655":"50b283db","739":"f243c2e5","787":"7f5bd347","815":"7bfee885","907":"5be7001f","945":"465ea938","954":"d71f3094","979":"af2c67ca"}[chunkId] + ".chunk.js";
};